/* app/ui/listing/deals-filter */

define(
	'app/ui/listing/deals-filter',[
		'jquery',
		'util/core',
		'templayed',
		'text!templates/pagination.html',
		'text!templates/filtersummary.html',

		'pubsub'
	],
	function ($, Core, templayed, paginationTemplate, summaryTemplate) {

		var selectors = Object.freeze({
			dealsContainer: '.js-deals',
			filterContainer: '.js-deals-filter',
			filterInput: '.js-deals-filter__input',
			filterOption: '.js-filter-option',
			listContainer: '.js-deals-filter__list',
			listEmpty: '.js-deals-filter__no-results',
			pagesContainer: '.js-deals-filter__pages',
			pageLink: '.js-pagination-link',
			pageSelect: '.js-pagination-dropdown',
			summaryContainer: '.js-summary-container',
		});

		var module = {
			init: function() {
				if ($(selectors.filterContainer)) {
					paginationTemplate = paginationTemplate.replace(/\r/g, '');
					summaryTemplate = summaryTemplate.replace(/\r/g, '');
					module._initEvents();
					var $deals = $(selectors.dealsContainer);
					$deals.each(function() {
						$(this).data('filter-state',
							{
								categories: [],
								page: 1,
								pageSize: 8,
								pagination: {
									total: 0,
									pages: [],
									pageCount: 0,
									currentPage: 1,
									hasPrevPage: false,
									hasNextPage: false,
									prevPageUrl: '',
									nextPageUrl: ''
								}
							});
						module._updateDisplay($(this));
					});

				}
			},

			_initEvents: function() {
				$(selectors.filterInput).on('change', module._updateFilters);
				$(selectors.pagesContainer).on('click', selectors.pageLink, module._updatePage);
				$(selectors.pagesContainer).on('change', selectors.pageSelect, module._selectPage);
				$('.js-filter-toggle, .js-filter-cancel, .js-filter-apply').on('click', module._toggleFilter);
				$(selectors.summaryContainer).on('click', selectors.filterOption, module._removeFilterOption);
			},

			_toggleFilter: function (event) {
				event.preventDefault();

				$.publish('/operator/listing/overlay');
				$.publish('/header/hide');

				var $deals = $(event.target).closest(selectors.dealsContainer);
				$deals.find(selectors.filterContainer).toggleClass('is-open');
			},

			_updateFilters: function (event) {
				var categories = $(event.target)
					.closest(selectors.dealsContainer)
					.find(selectors.filterInput)
					.map(function(index, elm) {
						if (elm.value) {
							return elm.value;
						}
					}).get();

				var $deals = $(event.target).closest(selectors.dealsContainer);
				var filterState = $deals.data('filter-state');
				filterState.categories = categories;
				filterState.page = 1;
				$deals.data('filter-state', filterState);

				module._updateDisplay($deals);
			},

			_updatePage: function (event) {
				event.preventDefault();
				var $item = $(event.currentTarget);
				var targetUrl = $item.attr('href');
				var query = Core.getQueryStringObject(targetUrl.split('?')[1]);
				var page = parseInt(query.obj.page, 10);

				var $deals = $(event.target).closest(selectors.dealsContainer);
				var filterState = $deals.data('filter-state');
				filterState.page = page;
				$deals.data('filter-state', filterState);

				module._updateDisplay($deals);
				Core.scrollToElm($deals);
			},

			_selectPage: function (event) {
				var $item = $(event.currentTarget);
				var page = parseInt($item[0].value, 10);

				var $deals = $item.closest(selectors.dealsContainer);
				var filterState = $deals.data('filter-state');
				filterState.page = page;
				$deals.data('filter-state', filterState);

				module._updateDisplay($deals);
				Core.scrollToElm($deals);
			},

			_removeFilterOption: function (event) {
				event.preventDefault();
				var $item = $(event.currentTarget);
				var $filter = $item
					.closest(selectors.dealsContainer)
					.find(selectors.filterInput)
					.filter(function(index, elm) {
						return $(elm).attr('name') === $item.data('filter-name');
					});

				$filter.val('');
				$filter.trigger('change');
			},

			_updateDisplay: function($dealContainer) {
				var filterState = $dealContainer.data('filter-state');

				// Hide all
				var $listContainer = $dealContainer.find(selectors.listContainer);
				if ($listContainer) {
					$listContainer.children().attr('aria-hidden', true);
				}

				// Filter on categories
				var matches = $listContainer.children().filter(function(idx, elm) {
					return module._isListItemCategoryMatch(filterState, elm);
				});
				var $filteredItems = $(Object.assign({}, matches));

				// Paginate
				module._updatePagination($dealContainer, matches.length);

				var startIndex = (filterState.page - 1) * filterState.pageSize;
				matches = matches.slice(startIndex, startIndex + filterState.pageSize);

				// Show
				$(matches).attr('aria-hidden', false);

				// Trigger Lazyload
				$(window).trigger('resize');

				// Hide filter options with no matches
				module._updateFilterOptions($dealContainer, $filteredItems);

				// Update Summary
				module._updateSummary($dealContainer);
			},

			_isListItemCategoryMatch: function (filterState, item) {

				var itemCategories = $(item).data('categories').split(',') || [];

				for (var i = 0, l = filterState.categories.length; i < l; i++) {
					if (itemCategories.indexOf(filterState.categories[i]) === -1) {
						// category not found
						return false;
					}
				}

				return true;
			},

			_updatePagination: function ($dealContainer, totalItems) {
				$dealContainer.find(selectors.pagesContainer).empty();
				var filterState = $dealContainer.data('filter-state');

				var pages = [];
				var numberOfPages = Math.ceil(totalItems / filterState.pageSize);

				for (var i = 1; i <= numberOfPages; i++) {

					if (Math.abs(i - filterState.page) > 7) {
						continue;
					}

					var page = {
						pageNumber: i,
						pageUrl: '?page=' + i,
						selectedClass: i === filterState.page ? 'is-selected' : '',
						selectedAttr: i === filterState.page ? ' selected="selected"' : '',
					};
					pages.push(page);
				}

				filterState.pagination = {
					total: totalItems,
					pages: pages,
					pageCount: numberOfPages,
					pageStart: ((filterState.page - 1) * filterState.pageSize) + 1,
					pageEnd: Math.min(((filterState.page - 1) * filterState.pageSize) + filterState.pageSize, totalItems),
					currentPage: filterState.page,
					hasPrevPage: filterState.page > 1,
					hasNextPage: filterState.page < numberOfPages,
					prevPageUrl: '?page=' + (filterState.page - 1),
					nextPageUrl: '?page=' + (filterState.page + 1)
				};
				$dealContainer.data('filter-state', filterState);

				if (numberOfPages > 1) {
					var compiledPagination = templayed(paginationTemplate)(filterState.pagination);
					$dealContainer.find(selectors.pagesContainer).html(compiledPagination);
				}
			},

			_updateFilterOptions: function ($dealContainer, $filteredItems) {
				var $filterInputs = $dealContainer.find(selectors.filterInput);
				var possibleCategories = {};

				$filteredItems.each(function(idx, item) {
					var itemCategories = $(item).data('categories').split(',') || [];

					for (var i = 0, l = itemCategories.length; i < l; i++) {
						var cat = itemCategories[i];
						if (possibleCategories[cat]) {
							possibleCategories[cat] += 1;
						} else {
							possibleCategories[cat] = 1;
						}
					}
				});

				var keys = Object.keys(possibleCategories);

				//$filterInputs.children().show();
				$filterInputs.children().each(function(idx, option) {
					var $option = $(option);
					var value = $option.val();
					if (value !== '' && keys.indexOf(value) === -1) {
						//console.log({
						//	value,
						//	idx: keys.indexOf(value)
						//});
						$option.attr('aria-hidden', true).hide();
					} else {
						$option.attr('aria-hidden', false).show();
					}
				});

				$filterInputs.each(function (idx, filter) {
					var $filter = $(filter);
					if ($filter.children().filter('[aria-hidden=false]').length > 1) {
						filter.removeAttribute('disabled');
					} else {
						filter.setAttribute('disabled', true);
					}
				});

				//console.log(keys);
			},

			_updateSummary: function ($dealContainer) {
				$dealContainer.find(selectors.summaryContainer).empty();
				var filterState = $dealContainer.data('filter-state');

				var dropdownFilters = $dealContainer.find(selectors.filterInput)
					.filter(function() {
						return $(this).val() !== '';
					})
					.map(function() {
						return {
							filterName: $(this).attr('name'),
							filterOption: $(this).find(':selected').text(),
							filterType: 'select'
						}
					});

				var summaryObj = {
					hasResults: filterState.pagination.pageEnd > 0,
					pageStart: Math.min(filterState.pagination.pageStart, filterState.pagination.total).toString(),
					pageEnd: Math.min(filterState.pagination.pageEnd, filterState.pagination.total).toString(),
					total: filterState.pagination.total.toString(),
					noResults: filterState.pagination.pageEnd === 0,
					dropdownFilters: dropdownFilters,
					inputFilters: [],
					checkboxFilters: [],
				};

				if (filterState.pagination.pageCount > 1 || summaryObj.dropdownFilters.length) {
					if (summaryObj.hasResults) {
						var compiledSummary = templayed(summaryTemplate)(summaryObj);
						$dealContainer.find(selectors.summaryContainer).html(compiledSummary);
						$dealContainer.find(selectors.listEmpty).hide();
					} else {
						$dealContainer.find(selectors.listEmpty).show();
					}
				}
			},
		};

		return {
			init: module.init
		};
	}
);
